export default {
    SUBMIT_IMPORTAR_DIRECCIONES_EXCEL: 'SUBMIT_IMPORTAR_DIRECCIONES_EXCEL',
    SUBMIT_IMPORTAR_DIRECCIONES_EXCEL_SUCCESS: 'SUBMIT_IMPORTAR_DIRECCIONES_EXCEL_SUCCESS',
    ABRIR_MODAL_IMPORTAR_DIRECCIONES_EXCEL: 'ABRIR_MODAL_IMPORTAR_DIRECCIONES_EXCEL',
    CERRAR_MODAL_IMPORTAR_DIRECCIONES_EXCEL: 'CERRAR_MODAL_IMPORTAR_DIRECCIONES_EXCEL',
    SUBIR_ARCHIVOS_IMPORTAR_DIRECCIONES_EXCEL: 'SUBIR_ARCHIVOS_IMPORTAR_DIRECCIONES_EXCEL',
    DESCARGAR_PLANTILLA_EXCEL_DIRECCIONES_EXCEL: 'DESCARGAR_PLANTILLA_EXCEL_DIRECCIONES_EXCEL',
    DESCARGAR_DIRECCIONES_EXCEL: 'DESCARGAR_DIRECCIONES_EXCEL'
  }